import { render, staticRenderFns } from "./addGarbage.vue?vue&type=template&id=2f1e6e6e&scoped=true"
import script from "./addGarbage.vue?vue&type=script&lang=js"
export * from "./addGarbage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e6e6e",
  null
  
)

export default component.exports